import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PresentPC from 'components/pages/Conf/PresentPC';
import PresentSP from 'components/pages/Conf/PresentSP';
import AppContext from 'fluxes/context';

import {
  CHANGE_VALID,
  UPDATE_RECEIPT_ID,
} from 'fluxes/actions';

import MeasureEvent from 'utils/measureEvent';
import { postRegisterRequestApi } from 'utils/api';
import { THANKS_URL, ADD_INPUT_URL, CHOICES_MAP, MEASURE_MAP } from 'utils/constant';
import {
  useDirectTransCheck,
  useWindowDimensions,
  getChoiceLabel,
  useIECheck,
  isFatalApiError,
  isSchemaValid,
  isCustomValid,
  randomID,
  scrollTop,
} from 'utils';

const Conf = () => {
  const path = window.location.pathname;
  const { state, dispatch } = useContext(AppContext);
  const [ receiptID, setReceiptID ] = useState(state.receiptID);
  const [ olodTarget, setOlodTarget ] = useState(state.olodTarget);
  const [ resultCheckEkiCode, setResultCheckEkiCode ] = useState(false);
  const [ isApiError, setIsApiError ] = useState(false);
  const [ showLoading, setShowLoding ] = useState(false);
  const history = useHistory();

  const {
    workCategory,
    workCategorySub,
    workCategoryOtherDetail,
    workDetailText,
    employmentPlacementDispatching,
    companyNameText,
    dept,
    chargePersonNameText,
    tel,
    email,
    address,
    ekiCd,
    ekiName,
    isRegistered,
    clickID,
    mediaID,
  } = state;

  // 直接遷移チェック
  useDirectTransCheck({ state });

  
  // 対象駅判定API
  useEffect(() => {
    const validation = async () => {
      // エラーチェックを実行
      console.log('valid:custom:checkEkiCode');
      const [ isValid ] = await isCustomValid({
        checks: [ 'checkEkiCode' ],
        target: { ekiCd },
      })
        .catch(err => {
          console.log(err);
          console.log('valid:custom:checkEkiCode：err');
          // FATELエラーチェック
          const isFatal = isFatalApiError(err);
          setIsApiError(isFatal);
          if(isFatal) throw err;
        });
        
      if(isValid){
        // 対象職種判定
        if(workCategory === 'A'){
          if(workCategorySub.length === 0){
            setOlodTarget(true);
            setResultCheckEkiCode(true);
          }else{
            setOlodTarget(false);
            setResultCheckEkiCode(false);
            if(workCategorySub.includes('A01')){
              setOlodTarget(true);
              setResultCheckEkiCode(true);
            }
          }
        }else{
          setOlodTarget(false);
          setResultCheckEkiCode(false);
        }
      }else{
        setOlodTarget(false);
        setResultCheckEkiCode(false);
      }
    };

    validation();

  }, [ ekiCd, ekiName, workCategorySub, workCategory ]);

  // 依頼ID発行
  useEffect(()=>{
    const id = randomID();
    setReceiptID(`OLOD-${id}`);
  }, []);

  // レスポンシブ
  const { width } = useWindowDimensions();
  const isIE = useIECheck();
  const isSp = width <= 640 && !isIE;

  // ボタン押下
  // state更新処理
  const onClickMainButton = {
    prev: () => {
      scrollTop();
    },
    next: (e) => {
      // イベント計測
      MeasureEvent(
        {
          linkTrackVars: MEASURE_MAP.EVENT_84.linkTrackVars,
          linkTrackEvents: MEASURE_MAP.EVENT_84.linkTrackEvents,
          events: MEASURE_MAP.EVENT_84.events,
        },
        MEASURE_MAP.EVENT_84.name,
      );
      scrollTop();
      setShowLoding(true);
      
      // 依頼IDを保存
      dispatch({
        type: UPDATE_RECEIPT_ID,
        updReceiptID: { receiptID },
      });

      const params = {
        workCategory,
        workCategorySub,
        workCategoryOtherDetail,
        workDetailText,
        employmentPlacementDispatching,
        companyNameText,
        dept,
        chargePersonNameText,
        tel,
        email,
        address,
        ekiCd,
        ekiName,
        receiptID,
        olodTarget,
        clickID,
        mediaID,
      };
    
      // データ登録処理
      e.preventDefault();
      // 二重登録
      if(isRegistered) {
        setIsApiError(true);
        return false;
      };
      const [ isPostValid ] = isSchemaValid({ path, target: params });
      if(!isPostValid){
        setIsApiError(true);
        return false;
      };
      // ok  
      dispatch({
        type: CHANGE_VALID, 
        path,
        valid: isPostValid,
      });

      // 更新処理
      postRegisterRequestApi({ params })
        .then(() => {
          if(resultCheckEkiCode){
            history.push(ADD_INPUT_URL);
          }else{
            history.push(THANKS_URL);
          }
        })
        .catch(err => {
          //  派遣依頼登録 FATELエラーチェック
          const isFatal = isFatalApiError(err);
          setIsApiError(isFatal);
          if(isFatal) throw err;
        
          // 400エラーは基本的に起きないためFATAL
          if(err.response.status === 400) {
            setIsApiError(true);
            return false;
          };
          return false;
        });
      return true;
    },
  };

  const getWorkCategorySub = ( value, category) => {
    if(value.length === 0) return '';
    if(!value) return '';
    let choiceName = '';
    if(category === 'A'){
      choiceName = 'workOfficeTypeList';
    }else if(category === 'B'){
      choiceName = 'workITTypeList';
    }else if(category === 'C'){
      choiceName = 'workMarketingTypeList';
    }
    const choices = CHOICES_MAP[choiceName];
    const target = choices.filter(choice => value.includes(choice.value) );
    return target || '';
  };
  
  // 画面表示用テキスト
  const confList = [
    { text: 'ご検討の職種',
      children: getChoiceLabel('workCategoryList', workCategory ),
      questionMark: true,
      popUpTitle: '職種について',
      popUpDetail: (
        <span>
          <p>法律上の派遣禁止業務（港湾運送・建設・警備・医療・士業）や製造業務等、一部の業務は弊社のサービスの対象外となる可能性がございます。</p>
        </span>
      ),
    },
    { text: workCategory === 'E' ? 'ご検討の職種を記載してください' : '職種を選択してください',
      children: workCategory === 'E' ? workCategoryOtherDetail : getWorkCategorySub(workCategorySub, workCategory),
      questionMark: false,
      isCloseState: workCategory === 'D',
    },
    { text: 'お仕事内容の詳細',
      children: workDetailText,
      questionMark: true,
      popUpTitle: '',
      popUpDetail: (
        <span>
          <p>
            例）
            <br />
            期間：20xx年4月1日より1年間
            <br />
            人数：2名
            <br />
            勤務時間：9時～17時、週5日勤務（土日祝休み）
            <br />
            残業：5~10時間／月（繁忙期10~20時間／月）
            <br />
            必要スキル：Excelで表、グラフが作成できる方
            <br />
          </p>
        </span>),
    },
    { text: '紹介予定派遣の希望',
      children: employmentPlacementDispatching ? '希望する' : '希望しない',
      questionMark: true,
      popUpTitle: '紹介予定派遣について',
      popUpDetail: (
        <span>
          <p>
            「紹介予定派遣」とは、社員として採用することを前提に、派遣社員を一定期間受入、派遣期間中に社員としての適性を見極めることができる仕組みです。
            <br />
            <br />
            詳細は
            <a className="link-grey" href="/sol/contents/client/ttoh/" target="_blank" rel="noopener noreferrer">こちら</a>
          </p>
        </span>),
    },
    { text: '企業名',
      children: companyNameText,
      questionMark: false,
    },
    { text: '派遣先部課名',
      children: dept,
      questionMark: true,
      popUpTitle: '',
      popUpDetail: (
        <span>
          派遣先部課名がない場合は「なし」と入力してください
        </span>),
    },
    { text: 'ご担当者名',
      children: chargePersonNameText,
      questionMark: false,
    },
    { text: '電話番号',
      children: tel,
      questionMark: false,
    },
    { text: 'メールアドレス',
      children: email,
      questionMark: false,
    },
    { text: '派遣先住所',
      children: address,
      questionMark: true,
      popUpTitle: '',
      popUpDetail: (
        <span>
          <p>
            下記エリアはサービス対象外となりますのでご了承ください。
            <br />
            青森県・山形県・新潟県・長野県・山梨県・富山県・石川県・福井県・鳥取県・島根県・岡山県・山口県・和歌山県・愛媛県・高知県・徳島県・香川県・長崎県・大分県・宮崎県・鹿児島県・沖縄県
          </p>
        </span>
      ),
    },
    { text: '派遣先最寄り駅',
      children: ekiName,
      questionMark: false,
    },
  ];


  // 画面表示
  return isSp ? (
    <PresentSP 
      confList={confList}
      
      onClickMainButton={onClickMainButton}
      isApiError={isApiError}
      showLoading={showLoading}
    />
  ) : (
    <PresentPC 
      confList={confList}

      onClickMainButton={onClickMainButton}
      isApiError={isApiError}
      showLoading={showLoading}
    />
  );
};

export default Conf;
